import React from "react";
import * as c from "./blogPostCard.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { AuthorPhotoNameTitle, AuthorOneLine } from "@components/blog/author";
import classNames from "classnames";

const BlogPostCard = ({ className, post, size = "sm" }) => {
  if (!post || !post.featureImage) {
    return <></>;
  }

  const CategoryLinks = () => (
    <>
      {post?.categories?.map(({ path, name }, idx) => (
        <React.Fragment key={`BlogPostCard-CategoryLink-${name}-${post.id}`}>
          {idx >= 1 && idx % 2 && <span>&nbsp;&bull;&nbsp;</span>}
          <Link className={c.categoryLink} to={path}>
            {name}
          </Link>
        </React.Fragment>
      ))}
    </>
  );

  const AuthorOneLineContent = (
    <AuthorOneLine className={c.onelinemd} author={post?.author} publishedAt={post?.publishedAt} />
  );
  const AuthorPhotoNameContent = <AuthorPhotoNameTitle author={post?.author} />;

  const variations = {
    sm: {
      eyebrow: <CategoryLinks />,
      Subhead: null,
      Author: AuthorOneLineContent,
      imageLoading: "lazy",
    },
    md: {
      eyebrow: <CategoryLinks />,
      Subhead: <p className={c.subhead}>{post?.subhead?.subhead}</p>,
      Author: AuthorOneLineContent,
      imageLoading: "eager",
    },
    lg: {
      eyebrow: "FEATURED ARTICLE",
      Subhead: <p className={c.subhead}>{post?.subhead?.subhead}</p>,
      Author: AuthorPhotoNameContent,
      imageLoading: "eager",
    },
  };

  const config = variations[size];

  return (
    <article className={classNames(className, c.container, c[size])}>
      <Link className={c.featureImageWrapper} to={post?.path}>
        <GatsbyImage
          className={c.imageFull}
          objectFit="cover"
          objectPosition="center center"
          loading={config.imageLoading}
          image={getImage(post.featureImage.full)}
          alt={post.title}
        />
      </Link>

      <header className={c.text}>
        <h3 className={c.eyebrow}>{config.eyebrow}</h3>
        <Link to={post?.path} className={c.titleLink}>
          <h2 className={c.title}>{post.title}</h2>
        </Link>

        {config.Subhead}

        {config.Author}
      </header>
    </article>
  );
};

export { BlogPostCard };
